import { Component, OnDestroy, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ClinicalFeedbackConstants } from '@app/clinical-feedback/clinical-feedback-constants';
import { Subscription } from 'rxjs';
import { FeedbackTypeOption, FormElementModel } from 'src/app/clinical-feedback/clinical-feedback.model';
import { NewClinicalFeedbackFormHelper, ShowLogic } from '../../new-clinical-feedback.helper';

@Component({
    selector: 'app-addendum-form',
    templateUrl: './addendum-form.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class AddendumFormComponent implements OnInit, OnDestroy {
    public formControlName = 'addendum';
    public formGroup!: UntypedFormGroup;
    formElementModels = {
        addendumDetails: new FormElementModel({
            id: 'addendumDetails',
            label: 'If the hospital has already completed an addendum, please insert the addendum',
            placeholder: 'Add text',
            errorMessages: {
                required: ClinicalFeedbackConstants.ERROR_MESSAGE_REQUIRED
            }
        }),
        addendumCompletedAtHospital: new FormElementModel({
            id: 'addendumCompletedAtHospital',
            label: 'Was an addendum completed at the hospital?'
        }),
        elrAddendumRequired: new FormElementModel({
            id: 'elrAddendumRequired',
            label: 'Do you want Everlight to create an addendum?'
        })
    };
    private readonly subscriptions = new Subscription();
    public showElrAddendumRequired = false;
    public showAddendumDetails = false;

    constructor(private readonly fb: UntypedFormBuilder, public parent: FormGroupDirective) {}

    ngOnInit(): void {
        this.formGroup = this.fb.group({
            addendumCompletedAtHospital: ['', Validators.required],
            addendumDetails: [{ value: '', disabled: true }, Validators.required],
            elrAddendumRequired: [{ value: '', disabled: true }, Validators.required]
        });

        this.parent.form.addControl(this.formControlName, this.formGroup);
        this.handleFormValueChanges();
    }

    handleFormValueChanges() {
        this.subscriptions.add(
            NewClinicalFeedbackFormHelper.SetVisibilityOfControlsOnBooleanEvent(
                this.formControls['addendumCompletedAtHospital'].valueChanges,
                [this.formControls['elrAddendumRequired']],
                (visibility: boolean) => {
                    this.showElrAddendumRequired = visibility;
                },
                ShowLogic.ShowOnNo
            )
        );
        this.subscriptions.add(
            NewClinicalFeedbackFormHelper.SetVisibilityOfControlsOnBooleanEvent(
                this.formControls['addendumCompletedAtHospital'].valueChanges,
                [this.formControls['addendumDetails']],
                (visibility: boolean) => {
                    this.showAddendumDetails = visibility;
                },
                ShowLogic.ShowOnYes
            )
        );
    }

    get feedbackForm() {
        return (this.parent.form.get('feedback') as UntypedFormGroup).controls;
    }

    get formControls() {
        return this.formGroup.controls;
    }

    feedbackTypeAllowed() {
        return (
            this.feedbackForm['feedbackType']?.value === FeedbackTypeOption.AdvisedSeriousIncident ||
            this.feedbackForm['feedbackType']?.value === FeedbackTypeOption.ClinicalFeedback
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
